(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wh-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  var modal = document.getElementById('wh-modal');
  if (!modal) return;
  var body = document.getElementById('wh-modal-body');
  var lastFocus = null;

  function open(id) {
    var src = document.querySelector('[data-wh-modal-source="' + id + '"]');
    if (!src) return;
    body.innerHTML = src.innerHTML;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lastFocus = document.activeElement;
    var focusable = modal.querySelector('button, a, input, textarea, select, [tabindex]');
    if (focusable) focusable.focus();
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    body.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-wh-modal-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-wh-modal-open')); return; }
    if (e.target.closest('[data-wh-modal-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    if (e.key === 'Tab' && modal.classList.contains('is-open')) {
      var f = modal.querySelectorAll('button, a[href], input, textarea, select, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
